// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/chunk-" + chunkId + "." + {"658":"224e863d059ddc78bfcb","854":"5f8d6973c0e779889e22"}[chunkId] + ".js";
};